// src/pages/ApiDocumentation.js
import React from 'react';
import { Container, Card, Table, Alert } from 'react-bootstrap';

const ApiDocumentation = () => {
    return (
        <Container fluid>
            <h1 className="mb-4">API Dokumentace</h1>

            <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-white">
                    <h5 className="mb-0">Přehled</h5>
                </Card.Header>
                <Card.Body>
                    <p>
                        API umožňuje programově přistupovat k datům o monitorovaných webech. Každý web má svůj vlastní API klíč,
                        který je potřeba použít pro autentizaci.
                    </p>

                    <Alert variant="info">
                        <i className="fas fa-info-circle me-2"></i>
                        API klíč můžete vygenerovat v detailu webu na záložce "API".
                    </Alert>
                </Card.Body>
            </Card>

            <Card className="mb-4 shadow-sm">
                <Card.Header className="bg-white">
                    <h5 className="mb-0">Autentizace</h5>
                </Card.Header>
                <Card.Body>
                    <p>
                        Pro autentizaci použijte HTTP hlavičku <code>Authorization</code> s hodnotou <code>Bearer YOUR_API_KEY</code>.
                    </p>

                    <div className="bg-light p-3 rounded">
                        <h6>Příklad:</h6>
                        <pre className="mb-0" style={{ backgroundColor: 'transparent' }}>
                            <code>
                                {`curl -H "Authorization: Bearer a1b2c3d4-5e6f-7g8h-9i0j-k1l2m3n4o5p6" \\\n     ${process.env.REACT_APP_API_URL || 'https://monitor.vilemis.cz/api'}/api/websites/123/status`}
                            </code>
                        </pre>
                    </div>
                </Card.Body>
            </Card>

            <Card className="shadow-sm">
                <Card.Header className="bg-white">
                    <h5 className="mb-0">Dostupné endpointy</h5>
                </Card.Header>
                <Card.Body className="p-0">
                    <Table responsive hover className="mb-0">
                        <thead>
                        <tr>
                            <th>Metoda</th>
                            <th>Endpoint</th>
                            <th>Popis</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td><code>GET</code></td>
                            <td><code>/api/websites/{'{id}'}/status</code></td>
                            <td>Získá aktuální stav webu včetně dostupnosti, výkonu a bezpečnosti</td>
                        </tr>
                        <tr>
                            <td><code>GET</code></td>
                            <td><code>/api/monitoring/results</code></td>
                            <td>Získá výsledky monitoringu podle zadaných parametrů (websiteId, type, limit)</td>
                        </tr>
                        <tr>
                            <td><code>GET</code></td>
                            <td><code>/api/websites/{'{id}'}</code></td>
                            <td>Získá základní informace o webu</td>
                        </tr>
                        <tr>
                            <td><code>POST</code></td>
                            <td><code>/api/monitoring/run/{'{id}'}/{'{type}'}</code></td>
                            <td>Spustí konkrétní typ monitoringu (uptime, performance, security, seo)</td>
                        </tr>
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default ApiDocumentation;